import Vue from 'vue';
import Vuetify from 'vuetify/lib';
// import 'material-design-icons-iconfont/dist/material-design-icons.css' // Ensure you are using css-loader
import '@mdi/font/css/materialdesignicons.css'

Vue.use(Vuetify,{
  iconfont: 'mdi'
  });

export default new Vuetify({
});
